import React from 'react';

const OurCutomers = () => (
  <div>
    OurCutomers
  </div>
);

export default OurCutomers;
